import './account.scss';

class Account {
    constructor (context) {
        this.$context = context;
        this.$userKitchens = null;
    }

    initialize () {
        this.$userKitchens = this.$context.querySelectorAll('[data-kitchen-item]');
        this.$overlay = document.querySelector('[data-overlay]');

        if (this.$userKitchens.length > 0) {
            this.initUserKitchen();
        }

        if (this.$overlay) {
            this.initOverlay(this.$overlay);
        }
    }

    initUserKitchen () {
        import('../op-actions/op-actions').then(({ OPActions }) => {
            new OPActions({ // eslint-disable-line
                elements: [{
                    selector: 'data-copy',
                    confirmation: false,
                    type: 'copy'
                }, {
                    selector: 'data-share',
                    confirmation: false,
                    type: 'share'
                },
                {
                    selector: 'data-delete',
                    confirmation: true,
                    type: 'delete'
                }]
            });
        });
    }

    initOverlay ($overlay) {
        import('../../components/overlay/overlay').then(({ Overlay }) => {
            const $$overlay = new Overlay($overlay);
            $$overlay.initialize();
        });
    }
}

export { Account };

window.addEventListener('content.loaded', (e) => {
    const eventDetails = e.detail;
    const $context = eventDetails.$context;

    if ($context) {
        const $account = document.querySelector('[data-account="root"]');

        if ($account) {
            const account = new Account($context);

            account.initialize();
        }
    }
});
